function setInputSelection(input, start, end) {
    if (void 0 === end) end = start;
    input.setSelectionRange(start, end);
}
function getInputSelection(input) {
    if (!input) return {
        start: null,
        end: null,
        length: 0
    };
    const start = input.selectionStart;
    const end = input.selectionEnd;
    return {
        start,
        end,
        length: (null != end ? end : 0) - (null != start ? start : 0)
    };
}
function isInputFocused(input) {
    if (!input) return false;
    const rootNode = input.getRootNode();
    const activeElement = 'activeElement' in rootNode ? rootNode.activeElement : null;
    return activeElement === input;
}
export { getInputSelection, isInputFocused, setInputSelection };
